import * as React from "react";
const SvgFiRrPyramid = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pyramid_svg__a)">
      <path
        fill="#062147"
        d="M20.036 24H3.964a3.954 3.954 0 0 1-3.542-5.733L8.46 2.189A3.93 3.93 0 0 1 11.736.008a3.98 3.98 0 0 1 3.805 2.181l8.037 16.078A3.962 3.962 0 0 1 20.036 24M2 20.043A1.973 1.973 0 0 0 3.964 22h16.072A1.973 1.973 0 0 0 22 20.043a1.95 1.95 0 0 0-.212-.881L13.753 3.083a1.96 1.96 0 0 0-3.506 0L2.21 19.162a1.95 1.95 0 0 0-.21.881"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pyramid_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPyramid;
